import { Brain } from 'lucide-react';
import Spinner from '@/components/ui/Spinner';

export default function LoadingOverlay() {
    return (
        <div className="fixed inset-0 z-[9999] bg-bg-primary flex flex-col items-center justify-center animate-fade-in">
            <div className="relative mb-8">
                <div className="w-20 h-20 rounded-2xl bg-gradient-to-br from-accent-blue to-accent-purple flex items-center justify-center shadow-2xl animate-pulse">
                    <Brain size={40} className="text-white" />
                </div>
                {/* Decorative orbits */}
                <div className="absolute inset-0 border-2 border-accent-blue/20 rounded-full scale-150 animate-[spin_10s_linear_infinite]" />
                <div className="absolute inset-0 border border-accent-purple/20 rounded-full scale-[2] animate-[spin_15s_linear_infinite_reverse]" />
            </div>

            <div className="text-center space-y-4">
                <h1 className="text-2xl font-bold bg-gradient-to-r from-accent-blue to-accent-purple bg-clip-text text-transparent tracking-tight">
                    Iniciando Ares
                </h1>
                <div className="flex items-center justify-center gap-3 text-text-secondary font-medium">
                    <Spinner size="sm" />
                    <span className="text-sm uppercase tracking-widest opacity-70">
                        Sincronizando flota...
                    </span>
                </div>
            </div>

            <div className="absolute bottom-12 text-[10px] text-text-subtle uppercase tracking-[0.2em] font-semibold opacity-40">
                PR Mob
            </div>
        </div>
    );
}
